export default __webpack_public_path__ + "static/media/citywithdots.13eb18d7.svg";